import React, { useState, useRef } from "react";
import Header01 from "../components/Headers/Header01";
import { alphabets } from "../Data";
import ReactPlayer from 'react-player'
import PlayOverlay from "../components/PlayOverlay";
// import NextPreviousBTN from '../components/NextPreviousBTN'
// import AnimalWithName from '../components/AnimalWithName'
// import AudioPlayer from '../components/AudioPlayer'
// import TraceGame from '../components/TraceGame'
import TraceGame02 from "../components/TraceGame02";
import { motion } from "framer-motion";

type Props = {};

const TraceALetter = (props: Props) => {
  const [CurrentLetter] = useState<number>(0);
  const [ClickToPlay, setClickToPlay] = useState<boolean>(true);
  const letter =
    "M 173.474 93.042 L 173.474 91.799 Q 173.474 68.539 160.424 55.755 Q 149.617 45.168 130.103 43.348 A 91.346 91.346 0 0 0 121.628 42.971 A 98.372 98.372 0 0 0 104.907 44.303 Q 95.852 45.867 88.578 49.267 A 48.809 48.809 0 0 0 79.458 54.778 A 79.992 79.992 0 0 0 68.547 64.797 Q 61.719 72.428 58.24 80.968 L 8.346 69.604 A 108.272 108.272 0 0 1 19.288 47.121 A 87.432 87.432 0 0 1 34.359 29.387 A 105.938 105.938 0 0 1 73.865 7.015 A 156.379 156.379 0 0 1 120.918 0.002 A 158.102 158.102 0 0 1 142.134 1.493 A 195.28 195.28 0 0 1 155.63 3.819 A 103.747 103.747 0 0 1 190.076 17.757 A 73.492 73.492 0 0 1 210.933 37.783 A 91.685 91.685 0 0 1 216.443 46.61 Q 224.75 61.721 226.356 84.051 A 155.1 155.1 0 0 1 226.741 95.172 L 226.741 276.28 L 174.895 276.28 L 174.895 238.993 L 172.764 238.993 Q 167.692 249.138 157.622 258.938 A 106.411 106.411 0 0 1 157.317 259.235 A 72.09 72.09 0 0 1 143.904 269.338 A 97.947 97.947 0 0 1 130.861 275.747 A 84.164 84.164 0 0 1 113.708 280.57 Q 103.781 282.317 92.153 282.317 A 119.713 119.713 0 0 1 63.841 279.083 A 100.926 100.926 0 0 1 45.278 272.64 Q 24.327 262.963 12.164 244.497 A 72.109 72.109 0 0 1 1.73 218.248 A 99.977 99.977 0 0 1 0.001 199.221 Q 0.001 180.421 5.89 167.039 A 53.445 53.445 0 0 1 8.879 161.223 A 65.515 65.515 0 0 1 32.849 137.608 A 120.696 120.696 0 0 1 57.485 126.955 A 141.095 141.095 0 0 1 66.585 124.469 A 335.394 335.394 0 0 1 104.582 117.722 Q 129.085 114.881 144.355 113.017 Q 159.625 111.152 166.55 106.891 A 14.026 14.026 0 0 0 173.186 96.734 A 22.513 22.513 0 0 0 173.474 93.042 Z M 173.652 177.914 L 173.652 142.757 Q 171.363 145.046 165.675 147.047 A 62.289 62.289 0 0 1 162.732 147.995 A 128.066 128.066 0 0 1 154.098 150.215 Q 149.504 151.236 144.355 152.079 A 760.936 760.936 0 0 1 125.514 154.93 A 697.935 697.935 0 0 1 124.291 155.098 Q 114.762 156.397 108.275 157.274 A 7611.148 7611.148 0 0 1 107.956 157.317 A 142.863 142.863 0 0 0 91.448 160.357 A 115.417 115.417 0 0 0 79.813 163.887 A 55.903 55.903 0 0 0 69.043 169.092 A 43.018 43.018 0 0 0 59.572 177.115 Q 52.07 185.676 52.026 199.764 A 53.266 53.266 0 0 0 52.025 199.931 A 42.324 42.324 0 0 0 53.746 212.337 A 31.88 31.88 0 0 0 66.585 229.671 Q 80.334 239.145 101.209 239.672 A 98.429 98.429 0 0 0 103.695 239.703 A 93.169 93.169 0 0 0 121.678 238.053 A 67.28 67.28 0 0 0 141.425 231.003 A 65.928 65.928 0 0 0 157.091 219.145 A 57.709 57.709 0 0 0 165.396 208.187 Q 173.652 194.071 173.652 177.914 Z";

  const [success, setSuccess] = useState(false);

  const playerRef = useRef<ReactPlayer | null>(null);
  const [Audio, setAudio] = useState<null | string>(null);
  const [Playing, setPlaying] = useState<boolean>(false);  

  const ParrotMotion = {
    start: {
      x: 1000,
      opacity: 0,
    },
    show: {
      transition: { delay: 1.5 },
      opacity: 1,
      x: 0,
    },
  };

  const TraceMotion = {
    start: {
      x: -1000,
      opacity: 0,
    },
    show: {
      transition: { delay: 1.5 },
      opacity: 1,
      x: 0,
    },
  };

  const ParrotChatMotion = {
    start: {
      x: 1000,
      opacity: 0,
    },
    show: {
      transition: { delay: 2 },
      opacity: 1,
      x: 0,
    },
  };

  const FromTop = {
    start: {
      y: 1000,
      opacity: 0,
    },
    show: {
      transition: { delay: 1 },
      opacity: 1,
      y: 0,
    },
  };

  const SuccessDialogue = () => {
    return (
      <motion.div
        variants={FromTop}
        initial="start"
        animate="show"
        className={`flex flex-col p-4 relative justify-center lg:w-1/5 w-1/2 bg-white rounded-xl z-100 shadow-lg`}
      >
        <div className="flex flex-row justify-end ">
          <div className="cursor-pointer" onClick={() => setSuccess(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
        </div>

        <div
          className={`flex flex-col self-center justify-center items-center p-4`}
        >
          <img
            src="success.png"
            alt="success"
            className={`relative w-[70%] self-center p-4`}
          />
          <p className={`text-xl font-extrabold`}>Success</p>
        </div>
      </motion.div>
    );
  };

  return (
    <div className={`w-full h-screen flex flex-col justify-between z-0`}>
      

      {Audio && Playing ? (
        <div className="hidden">
          <ReactPlayer
            url={Audio}
            config={{
              file: { forceAudio: true },
            }}
            onPlay={() => {
              console.log("Audio Playing");
            }}
            onEnded={() => {
              setPlaying(false);
            }}
            loop={false}
            controls
            playing={Playing}
            ref={playerRef}
          />
        </div>
      ) : null}
      
      {/* Success dialogue */}
      {success ? (
        <div className="h-screen w-screen flex flex-col justify-center items-center fixed left-0 top-0 bottom-0 right-0 z-40 inset-0">
          <div
            className={`flex flex-col justify-center bg-green-50 opacity-[70%] absolute w-full h-full left-0 top-0 bottom-0 right-0`}
          ></div>
          <SuccessDialogue />
        </div>
      ) : null}

      {/* BG Music */}
      {/* <div className="hidden">
        <BgAudioPlayer ClickToPlay={ClickToPlay} />
      </div> */}

      {/* Header */}
      <Header01 letter={alphabets[CurrentLetter]} />

      {ClickToPlay ? (
        <PlayOverlay setClickToPlay={setClickToPlay} />
      ) : (
        <div
          className={`flex flex-row flex-wrap px-[3%] justify-evenly relative`}
        >
          {/* Trace */}
          <motion.div
            variants={TraceMotion}
            initial="start"
            animate="show"
            className="flex flex-col justify-center z-10"
          >
            <TraceGame02 letter={letter} setSuccess={setSuccess} />
          </motion.div>
          <div className="flex flex-col gap-2 lg:w-[35%] sm:w-[65%] md:w-[55%] justify-center my-[2%]">
            {/* Parrot Bubble chat */}
            <motion.div
              variants={ParrotChatMotion}
              initial="start"
              animate="show"
              whileTap={{
                rotate: [0, -10, 10, -10, 10, 0],
                transition: { duration: 0.3 }
              }}
              className={`z-1 sm:w-[60%] md:w-[70%] lg:w-[60%] self-start cursor-pointer`}
              onClick={() => {
                if (Playing === false) {
                  setAudio("/music/writeTheLetterA.mp3");
                  setPlaying(true);
                } else {
                  setPlaying(false);
                  setAudio(null);
                }
              }}
            >
              <div className="relative">
                <img src="/Others/SpeechBubble.png" alt="Wilf" className={``} />
                <div className="absolute inset-0 flex flex-col mb-16 justify-center items-center z-2 p-2">
                  <p className={`font-extrabold lg:text-3xl text-xl`}>
                    Write the letter
                  </p>
                  <h4
                    className={`font-extrabold lg:text-8xl text-2xl word-primary`}
                  >
                    '{alphabets[CurrentLetter]}'
                  </h4>
                </div>
              </div>
            </motion.div>
            {/* Parrot Image */}
            <motion.div
              variants={ParrotMotion}
              initial="start"
              animate="show"
              className={`z-2 self-end`}
            >
              <img src="/Animals/ParrotOnPencil.png" alt="inclined bird" />
            </motion.div>
          </div>
        </div>
      )}

      {/* Next Previous buttons */}
      {/* <NextPreviousBTN setCurrentLetter={setCurrentLetter} CurrentLetter={CurrentLetter}/> */}
    </div>
  );
};

export default TraceALetter;
